/**
 * Intervenants d'une session, comme dans l'app : un état (participant, intervenant, alerte,
 * en route, en parcours…) qui choisit la couleur et le libellé, et un réglage « visible sur la
 * carte » que chacun choisit. Un intervenant qui ne veut pas être vu reste dans la liste.
 */
export const MEMBER_COLORS = Object.freeze({
    alert: '#D32F2F',
    intervenant: '#4CAF50',
    participant: '#2196F3',
    owner: '#FFC107',
    en_route: '#9C27B0',
    on_trail: '#00897B',
});

export const MEMBER_LABELS = Object.freeze({
    alert: 'En alerte',
    intervenant: 'Intervient',
    participant: 'Participant',
    owner: 'Organisateur',
    en_route: 'En route',
    on_trail: 'En parcours',
});

export const memberColor = state => MEMBER_COLORS[state] || MEMBER_COLORS.participant;
export const memberLabel = state => MEMBER_LABELS[state] || MEMBER_LABELS.participant;

/**
 * Applique un RESPONDER_UPDATE : la liste (session.members) garde tout le monde avec son état ;
 * la carte (session.responders) seulement ceux qui sont visibles. Position 0,0 : départ.
 */
export function applyResponderUpdate(session, info) {
    if (!info || !info.userId) return session;
    session.members = session.members || {};
    session.responders = session.responders || {};
    const lat = info.lat ?? info.latitude ?? 0;
    const lng = info.lng ?? info.longitude ?? 0;
    if (lat === 0 && lng === 0) {
        delete session.responders[info.userId];
        delete session.members[info.userId];
        return session;
    }
    const mapVisible = info.mapVisible !== false;
    session.members[info.userId] = {
        userId: info.userId,
        displayName: info.displayName || null,
        state: info.state || null,
        mapVisible,
    };
    if (!mapVisible) {
        delete session.responders[info.userId];
        return session;
    }
    session.responders[info.userId] = {
        userId: info.userId,
        userEmail: info.userEmail,
        displayName: info.displayName || null,
        lat,
        lng,
        status: info.status || 'ACTIVE',
        route: info.noRoute ? [] : (info.route || []),
        // Session partagée : participant, intervenant, alerte, en route, en parcours.
        state: info.state || null,
        alertSessionId: info.alertSessionId || null,
    };
    return session;
}
